
import DrawBase from "../DrawBase"
import EditRectangle from "./EditRectangle"
import StyleUtil from "@/utils/cesiumBD/utils/StyleUtil.js"
class DrawRectangle extends DrawBase {

    constructor(options) {
        super(options);
        //this.options.style = { material: "data/gg.svg" }
    }

    getEditInterface() {
        return EditRectangle;
    }

    getTypeName() {
        return "矩形";
    }

    getType() {
        return "rectangle_Nor";
    }
    checkLeftClick() {
        if (this.positionsTemp.length < 2) {
            return true;
        }
        return false;
    }
    addDynamicGraph(entity) {
        var $this = this;
        var positionsArr = undefined;
        var positions = [];
        var coordinatesProperty = new $this.Cesium.CallbackProperty(function () {
            $this.calculateKeyPositions();
            if ($this.positionsTemp.length < 2) {
                return [];
            }
            positions = $this.positions;
            if (!$this.isStarted && !positionsArr) {
                positions = $this.positions.slice();
            }
            var coordinates = $this.Cesium.Rectangle.fromCartesianArray(positions);
            return coordinates;
        }, false)
        var rectangle = this.createRectangle(coordinatesProperty);
        entity.rectangle = rectangle;
    }

    loadDynamicGraph(entity, data) {
        var $this = this;
        var positions = JSON.parse(data.editPositions);
        var coordinatesProperty = new $this.Cesium.CallbackProperty(function () {
            var coordinates = $this.Cesium.Rectangle.fromCartesianArray(positions);
            return coordinates;
        }, true)
        var rectangle = this.createRectangle(coordinatesProperty);
        entity.rectangle = rectangle;
        entity['edit_positions'] = positions;
        StyleUtil.setStyle2Entity(JSON.parse(data.styleAttr), entity, "rectangle");
        var postureAttr=data.postureAttr || "{}"
        postureAttr=JSON.parse(postureAttr);
        if(postureAttr && postureAttr.rotation && postureAttr.stRotation){
            entity.rectangle.rotation.setValue(postureAttr.rotation);
            entity.rectangle.stRotation.setValue(postureAttr.stRotation);
        }
    }
}

export default DrawRectangle;